import UserMultiMarkerOpen from './UserMultiMarkerOpen'
function UserMultiMarker({
  markers,
  isOpen,
  openMarker,
  close,
  openCard,
  point_count,
  visitsCount,
}) {
  if (isOpen)
    return (
      <div className="marker-wrapper multi-mark">
        <UserMultiMarkerOpen markers={markers} open={openCard} close={close} />
      </div>
    )

  return (
    <div className="marker-wrapper multi-mark" onClick={openMarker}>
      <MarkerAvatarUser count={point_count} visitsCount={visitsCount} />
    </div>
  )
}

export default UserMultiMarker

function MarkerAvatarUser(props) {
  return (
    <div className="marker--min">
      <svg
        className="multimark"
        viewBox="0 0 68 81"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_f)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M46.0666 66.0073C57.7586 63.9976 66 59.1549 66 53.5C66 46.0442 51.6731 40 34 40C16.3269 40 2 46.0442 2 53.5C2 59.237 10.4826 64.1382 22.4453 66.0931C22.2125 66.1688 22.3974 66.2438 23.1235 66.3136C29.6661 66.9429 33.9999 72 33.9999 72C33.9999 72 35.6328 67.9848 44.8076 66.3136C45.4362 66.1991 45.8461 66.0973 46.0666 66.0073Z"
            fill="url(#paint0_linear)"
            fillOpacity="0.3"
          />
        </g>
        <mask
          id="mask0"
          mask-type="alpha"
          maskUnits="userSpaceOnUse"
          x="2"
          y="0"
          width="64"
          height="72"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M41.9407 63.0071C55.7726 59.4754 66 46.9321 66 32C66 14.3269 51.6731 0 34 0C16.3269 0 2 14.3269 2 32C2 46.9321 12.2274 59.4754 26.0593 63.0071C26.0203 63.0025 26 63 26 63C26 63 28.7886 65.2898 30.2941 67.1176C31.9855 69.1711 34 72 34 72C34 72 36.0057 69.1869 37.6882 67.1398C39.1989 65.3015 42 63 42 63C42 63 41.9797 63.0025 41.9407 63.0071Z"
            fill="#202430"
          />
        </mask>
        <g mask="url(#mask0)">
          <rect x="-2" width="72" height="72" fill="white" />
        </g>
        <path
          d="M1.5 15.5C1.5 7.76801 7.76801 1.5 15.5 1.5C23.232 1.5 29.5 7.76801 29.5 15.5C29.5 23.232 23.232 29.5 15.5 29.5C7.76801 29.5 1.5 23.232 1.5 15.5Z"
          fill="#F8F8F8"
        />
        <text x="15" y="20" className="market__count">
          {props.count}
        </text>
        <path
          x="15"
          y="20"
          d="M15.5 28.5C8.3203 28.5 2.5 22.6797 2.5 15.5H0.5C0.5 23.7843 7.21573 30.5 15.5 30.5V28.5ZM28.5 15.5C28.5 22.6797 22.6797 28.5 15.5 28.5V30.5C23.7843 30.5 30.5 23.7843 30.5 15.5H28.5ZM15.5 2.5C22.6797 2.5 28.5 8.3203 28.5 15.5H30.5C30.5 7.21573 23.7843 0.5 15.5 0.5V2.5ZM15.5 0.5C7.21573 0.5 0.5 7.21573 0.5 15.5H2.5C2.5 8.3203 8.3203 2.5 15.5 2.5V0.5Z"
          fill="#DCDCDC"
        />
      </svg>
      <svg
        className="multimark center"
        viewBox="0 0 68 81"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M33.9119 19.8698C30.2915 19.8698 27.3835 22.7778 27.3835 26.3981C27.3835 30.0196 30.2913 32.9278 33.9119 32.9278C37.5325 32.9278 40.4402 30.0196 40.4402 26.3981C40.4402 22.7778 37.5322 19.8698 33.9119 19.8698ZM33.9119 21.9948C36.3586 21.9948 38.3152 23.9514 38.3152 26.3981C38.3152 28.846 36.3588 30.8028 33.9119 30.8028C31.4649 30.8028 29.5085 28.846 29.5085 26.3981C29.5085 23.9514 31.4651 21.9948 33.9119 21.9948ZM25.9109 21.2041C26.4977 21.2041 26.9734 21.6798 26.9734 22.2666C26.9734 22.8534 26.4977 23.3291 25.9109 23.3291C24.2273 23.3291 22.862 24.6939 22.862 26.3767C22.862 28.0595 24.2273 29.4243 25.9109 29.4243C26.4977 29.4243 26.9734 29.9 26.9734 30.4868C26.9734 31.0736 26.4977 31.5493 25.9109 31.5493C23.0539 31.5493 20.737 29.2333 20.737 26.3767C20.737 23.5201 23.0539 21.2041 25.9109 21.2041ZM47.1 26.3767C47.1 23.5201 44.783 21.2041 41.9261 21.2041C41.3393 21.2041 40.8636 21.6798 40.8636 22.2666C40.8636 22.8534 41.3393 23.3291 41.9261 23.3291C43.6096 23.3291 44.975 24.6939 44.975 26.3767C44.975 28.0595 43.6096 29.4243 41.9261 29.4243C41.3393 29.4243 40.8636 29.9 40.8636 30.4868C40.8636 31.0736 41.3393 31.5493 41.9261 31.5493C44.783 31.5493 47.1 29.2333 47.1 26.3767ZM46.0358 34.2029C45.3555 34.0493 44.6285 33.9444 43.8893 33.8934C43.3039 33.853 42.7966 34.2949 42.7563 34.8803C42.7159 35.4657 43.1577 35.973 43.7431 36.0134C44.3757 36.057 44.9956 36.1465 45.5984 36.2821C46.5358 36.4661 47.1469 36.771 47.2986 37.0888C47.4127 37.3287 47.4127 37.6108 47.2975 37.8536C47.1478 38.1683 46.5418 38.4717 45.6177 38.6617C45.0429 38.7799 44.6728 39.3416 44.791 39.9164C44.9091 40.4912 45.4709 40.8613 46.0457 40.7431C47.5731 40.429 48.692 39.869 49.217 38.7654C49.6062 37.9449 49.6062 36.9933 49.217 36.1749C48.6884 35.0672 47.5502 34.4994 46.0358 34.2029ZM25.0807 34.8803C25.0403 34.2949 24.533 33.853 23.9476 33.8934C23.2084 33.9444 22.4814 34.0493 21.772 34.209L21.4795 34.2709C20.1371 34.5776 19.1129 35.1413 18.6213 36.1748C18.2305 36.9925 18.2305 37.9457 18.6217 38.7663C19.1443 39.8687 20.2632 40.4289 21.7913 40.7431C22.3661 40.8613 22.9278 40.4912 23.046 39.9164C23.1642 39.3416 22.7941 38.7799 22.2193 38.6617C21.2955 38.4717 20.6901 38.1685 20.5408 37.8538C20.4246 37.61 20.4246 37.3296 20.5394 37.0894C20.691 36.7707 21.3015 36.466 22.2094 36.2883L22.6815 36.1916C23.1521 36.1046 23.6194 36.0461 24.0938 36.0134C24.6792 35.973 25.1211 35.4657 25.0807 34.8803ZM24.3201 39.3448C24.3201 35.9647 27.8163 34.776 33.9119 34.776L34.3437 34.778C40.1845 34.8329 43.5036 36.0243 43.5036 39.3201C43.5036 42.5383 40.3309 43.7706 34.7647 43.8806L33.9119 43.8889C27.8024 43.8889 24.3201 42.7211 24.3201 39.3448ZM41.3786 39.3201C41.3786 37.7468 38.8562 36.901 33.9119 36.901C28.9724 36.901 26.4451 37.7603 26.4451 39.3448C26.4451 40.9182 28.9667 41.7639 33.9119 41.7639C38.8499 41.7639 41.3786 40.9038 41.3786 39.3201Z"
          fill="url(#paint1_linear)"
        />
        <defs>
          <filter
            id="filter0_f"
            x="0"
            y="38"
            width="6"
            height="7"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur stdDeviation="1" result="effect1_foregroundBlur" />
          </filter>
          <linearGradient
            id="paint0_linear"
            x1="-83.6341"
            y1="37.8043"
            x2="-83.6341"
            y2="144.41"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopOpacity="0.01" />
            <stop offset="1" />
          </linearGradient>
          <linearGradient
            id="paint1_linear"
            x1="18.3282"
            y1="36.563"
            x2="47.4417"
            y2="23.7131"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#AF2D38" />
            <stop offset="1" stopColor="#E5264C" />
          </linearGradient>
        </defs>
      </svg>
      <div className="marker--min__label">
        <svg
          width="12"
          height="13"
          viewBox="0 0 12 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M1 6.5V11H3V6.5H1Z" fill="#A6ACBE" />
          <path d="M9 4V11H11V4H9Z" fill="#A6ACBE" />
          <path d="M5 2V11H7V2H5Z" fill="#A6ACBE" />
        </svg>
        {props.visitsCount}
      </div>
    </div>
  )
}
